/* eslint-disable */

const firstPresent = (...values) =>
  values.find((value) => value !== null && value !== undefined && value !== "");

export const getFormulaType = (formula = {}) =>
  firstPresent(
    formula.Type, formula.type, formula.FormulaType, formula.formulaType,
    formula.Formula?.Type, formula.formula?.type
  ) ?? null;

export const getFormulaValue = (formula = {}) => {
  const raw = firstPresent(
    formula.Value, formula.value, formula.FormulaValue, formula.formulaValue,
    formula.Formula?.Value, formula.formula?.value
  );
  if (raw == null) return null;
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
};

export const getFormulaId = (formula = {}) => {
  const raw = firstPresent(
    formula.Id, formula.id, formula.FormulaId, formula.formulaId,
    formula.Formula?.Id, formula.formula?.id
  );
  const id = Number(raw);
  return Number.isInteger(id) && id > 0 ? id : null;
};

export const getFormulaKey = (formula = {}) => {
  const type = String(getFormulaType(formula) ?? "").trim();
  const value = getFormulaValue(formula);
  return type && value != null ? `${type}|${value}` : null;
};

export const formatFormulaLabel = (formula, { fallback = "sin fórmula" } = {}) => {
  if (!formula) return fallback;
  const type = String(getFormulaType(formula) ?? "").trim();
  const value = getFormulaValue(formula);
  if (type && value != null) return `${type}${value}`;

  const legacyName = firstPresent(
    formula.Name, formula.name, formula.FormulaName, formula.formulaName,
    formula.Formula?.Name, formula.formula?.name
  );
  return String(legacyName ?? "").trim() || fallback;
};

export const dedupeFormulasByTypeValue = (formulas = []) => {
  const byKey = new Map();
  (Array.isArray(formulas) ? formulas : []).forEach((formula) => {
    const key = getFormulaKey(formula);
    if (!key) return;
    const current = byKey.get(key);
    const id = getFormulaId(formula) ?? Number.MAX_SAFE_INTEGER;
    const currentId = getFormulaId(current) ?? Number.MAX_SAFE_INTEGER;
    if (!current || id < currentId) byKey.set(key, formula);
  });
  return [...byKey.values()].sort(
    (left, right) =>
      (getFormulaId(left) ?? Number.MAX_SAFE_INTEGER) -
      (getFormulaId(right) ?? Number.MAX_SAFE_INTEGER)
  );
};

export const findCanonicalFormula = (formulas = [], formula = {}) => {
  const key = getFormulaKey(formula);
  return key
    ? dedupeFormulasByTypeValue(formulas).find((item) => getFormulaKey(item) === key) ?? null
    : null;
};
